import type { TourConfig } from '../../types/tour.types'

const lookAlikeTour: TourConfig = {
  id: 'lookalike',
  title: 'Find lookalike accounts',
  module: 'Prospecting',
  routeName: 'LookAlike',
  order: 4,
  autoStart: true,
  featureFlag: 'enableLookAlike',
  steps: [
    {
      id: 'intro',
      title: 'Clone your best customers',
      body: 'LookAlike finds new companies that resemble the customers you already win — plus the **contacts** to reach inside them. Upload a list of your best accounts and let AI-powered similarity matching hand you a fresh set of look-alike targets.',
    },
    {
      id: 'how',
      target: '.la-howitworks-card',
      placement: 'top',
      title: 'How it works',
      body: 'The idea is simple: **give us examples of great customers, we find more like them**. You upload a customer list, we match on the patterns that make them a fit, and you get new companies and contacts to target.',
    },
    {
      id: 'start',
      target: '.la-cta',
      placement: 'top',
      title: 'Start a new lookalike',
      body: 'Click here to begin. You\'ll upload a list of your current customers, and TAMI builds a set of similar companies — and the people to contact — from it.',
    },
    {
      id: 'previous',
      target: '[data-tour="la-previous"]',
      placement: 'top',
      title: 'Your past lookalikes',
      body: 'Every lookalike you run is saved here. Open any one to see the list of similar companies and contacts it found — ready to work or export like any other list.',
    },
  ],
}

export default lookAlikeTour
